import { ref, onMounted, onUnmounted } from 'vue'

/** 与 App.vue / index.html 一致：窄视口为「手机布局」 */
const MOBILE_MQ = '(max-width: 899px)'

export function useMobileLayout() {
  const isMobileLayout = ref(false)
  let mq = null
  const sync = () => {
    isMobileLayout.value = typeof window !== 'undefined' && window.matchMedia(MOBILE_MQ).matches
  }
  onMounted(() => {
    mq = window.matchMedia(MOBILE_MQ)
    sync()
    if (mq.addEventListener) mq.addEventListener('change', sync)
    else if (mq.addListener) mq.addListener(sync)
  })
  onUnmounted(() => {
    if (!mq) return
    if (mq.removeEventListener) mq.removeEventListener('change', sync)
    else if (mq.removeListener) mq.removeListener(sync)
  })
  return isMobileLayout
}
